import { HttpClient, HttpMethods } from "@planzone/services";
import {
  Group,
  Id,
  Identifiable,
  ProjectResource,
  Resource,
} from "@planzone/dto";
import { LinkedResource, Linker } from "../linkers/types";

type PlanzoneResponse = {
  _embedded: {
    planzoneResourceGroups: LinkedResource<
      Identifiable<Group<Identifiable<Resource>>>
    >[];
  };
};

type ProjectResponse = {
  _embedded: {
    projectResourceGroups: LinkedResource<
      Identifiable<Group<Identifiable<ProjectResource>>>
    >[];
  };
};

function getPlanzoneResourceGroups(httpClient: HttpClient, linker: Linker) {
  return () =>
    httpClient
      .sendHttpRequest<PlanzoneResponse>({
        endpoint: "/planzoneResourceGroups?size=9999",
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) => _embedded.planzoneResourceGroups)
      .then((groups) =>
        Promise.all(groups.map(linker.linkPlanzoneResourceGroup)),
      );
}

function getProjectResourceGroups(httpClient: HttpClient, linker: Linker) {
  return (projectId: Id) =>
    httpClient
      .sendHttpRequest<ProjectResponse>({
        endpoint: `/projects/${projectId}/groups?size=9999`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) => _embedded.projectResourceGroups)
      .then((groups) =>
        Promise.all(groups.map(linker.linkProjectResourceGroup)),
      );
}

function getResourceGroups(httpClient: HttpClient, linker: Linker) {
  return (resourceType: string, namespace: string) =>
    (resourceType === "project"
      ? getProjectResourceGroups(httpClient, linker)(namespace)
      : getPlanzoneResourceGroups(httpClient, linker)()
    ).then((groups) => groups.map((group) => ({ ...group, resourceType })));
}

export { getResourceGroups };
